var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "patrolTab",
        attrs: {
          type: "horizon",
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
          tabItems: _vm.tabItems,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    contentHeight: _vm.contentHeight,
                    popupParam: _vm.popupParam,
                    patrol: _vm.patrol,
                    child: _vm.child,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:patrol": function ($event) {
                      _vm.patrol = $event
                    },
                    "update:child": function ($event) {
                      _vm.child = $event
                    },
                    closePopup: _vm.closePopup,
                    transInfo: _vm.transInfo,
                    research: _vm.research,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }